var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 448.098 448.098",
    viewBox: "0 0 448.098 448.098",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m184.08 0c-101.62 0-184 82.38-184 184s82.38 184 184 184 184-82.38 184-184c-.088-101.584-82.416-183.912-184-184zm0 304c-66.274 0-120-53.726-120-120s53.726-120 120-120 120 53.726 120 120c-.088 66.238-53.762 119.912-120 120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m438.64 393.44-64-64c-12.504-12.504-32.776-12.504-45.28 0s-12.504 32.776 0 45.28l64 64c12.504 12.504 32.776 12.504 45.28 0s12.504-32.776 0-45.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch3);
export default __webpack_public_path__ + "static/media/search3.19a8d27baf78a45001b89859794f9a94.svg";
export { ForwardRef as ReactComponent };